import React, { useImperativeHandle, useState } from "react";
import { Button } from "@rneui/themed";
import { useJWT } from "@annunciate/core";
import { FAIcon } from "../../components";
import { BookmarkModal } from "./BookmarkModal";
export const BookmarkListButton = React.forwardRef(({ item, size, buttonStyle, iconStyle, closeParent }, ref) => {
    const jwt = useJWT();
    const [isOpen, setIsOpen] = useState(false);
    useImperativeHandle(ref, () => {
        return { toggle: () => setIsOpen(!isOpen) };
    }, [setIsOpen, isOpen]);
    if (!jwt)
        return null;
    return (React.createElement(React.Fragment, null,
        React.createElement(Button, { type: "clear", onPress: () => {
                setIsOpen(true);
            }, style: buttonStyle },
            React.createElement(FAIcon, { name: "bookmark", size: size, style: iconStyle })),
        isOpen && (React.createElement(BookmarkModal, { item: item, isOpen: isOpen, closeModal: () => {
                setIsOpen(false);
            }, closeParentModal: closeParent }))));
});
//# sourceMappingURL=BookmarkListButton.js.map